import "core-js/modules/web.dom.iterable";
export default {
  inserted: function inserted(el, binding) {
    var ariaEls = el.querySelectorAll('.el-radio__original');
    ariaEls.forEach(function (item) {
      item.removeAttribute('aria-hidden');
    });
  }
};